import FormNovaCompensacaoFeriado from '@/templates/ManutencaoDoPonto/Digitacao/forms/NovaCompensacaoFeriado'
import { TRCompensacaoFolga } from '@acme/core'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useAusenciasOutletContext } from 'pages/Ausencias.context'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { CompensacaoDia, compensacaoFolgas } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import IconeCadeado from './IconeCadeado'
import invalidateAusenciasQuery from './invalidateAusenciasQuery'

export default function EditarCompensacaoFolga() {
    const { id } = useParams()
    const { data, competencia } = useAusenciasOutletContext()
    const { mutateAsync } = compensacaoFolgas.mutations.useUpdate()
    const empresa = useStore(state => state.company)
    const isEdicaoBloqueada = empresa?.competenciaAtual !== competencia
    const row = data?.find(a => a.id === 'compensacao-folga_' + id) as
        | TRCompensacaoFolga
        | undefined
    if (!row || !empresa) return null

    const handleSubmit: SubmitHandler<CompensacaoDia> = data =>
        mutateAsync(
            {
                ...data,
                id: Number(String(row.id).split('_').at(-1)),
                dataFeriado: dayjs(data.dataFeriado).toDate(),
                dataCompensacao: dayjs(data.dataCompensacao).toDate(),
            },
            {
                onSuccess: async () => {
                    await invalidateAusenciasQuery()
                    toast.success('Compensação de folga editada com sucesso!')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            defaultValues={row}
            onSubmit={isEdicaoBloqueada ? undefined : handleSubmit}
            disableFields={isEdicaoBloqueada}
            open={hasPermission(['update', 'CompensaçãoDeFolgas'])}
        >
            <Dialog.Title>
                Editar compensação de folga{' '}
                {isEdicaoBloqueada && <IconeCadeado />}
            </Dialog.Title>
            <Dialog.Content>
                <FormNovaCompensacaoFeriado labelDataOrigem="Data da folga" />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
